import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';

const tagName = 'div';

register('wmx-component', () => {
  return {
    pre: attrs => `<${tagName} wmxComponent redrawable data-role="wmx component" ${getAttrMarkup(attrs)}>`,
    post: () => `</${tagName}>`
  };
});

export default () => {};
